export class AuthServiceInterface {
  static async authenticate (login, password) {
    throw new Error('Not implemented')
  }

  static async userInfo () {
    throw new Error('Not implemented')
  }
}
